import { PRIVACY_POLICY_PAGE } from '@wanderlust/shared';

/**
 * Where the consent banner and the settings dialog send someone to read the
 * privacy policy. The page's head metadata is `legalPageHead`, shared with
 * the other legal pages.
 */
export const PRIVACY_POLICY_PATH = PRIVACY_POLICY_PAGE.path;
